_ = require('lodash')
moment = require('moment')

HistoryService = ($http, TimeSeriesAnalysisService, $filter) ->
  get: (params) ->
    label = localStorage.getItem("#{params.user_id}_FILTER_PERIOD_SELECTED_LABEL")
    if label == $filter('translate')('_ANALYSIS.PERIOD_FILTER.ENTIRE_PERIOD') || label == null
      params.from = null
      params.to = null
    $http.get("/api/score_cards.json", params: params)

  convertToHistoryList: (scorecards) ->
    _(scorecards)
      .groupBy('yyyy')
      .toPairs()
      .sortBy((a) -> -a[0])
      .map((a) -> {key: a[0], value: a[1]})
      .value()

HistoryService.$inject = [
  '$http'
  'TimeSeriesAnalysisService'
  '$filter'
]

module.exports = HistoryService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/history/history-service.coffee